import { cva } from 'class-variance-authority'

export const listMenuItemLabelClass = 'min-w-0 flex-1 wrap-anywhere px-2 text-ui-body-b1 leading-ui-body-b1 font-medium'

export const listMenuItemVariants = cva(
  [
    'flex w-full cursor-pointer select-none items-center gap-2 rounded-300 px-3 py-1.5 text-left transition-colors outline-none',
    'bg-creation-neutral-container-surface-default text-creation-secondary-container-on-surface-default',
    '[&[data-selected]:not([data-disabled]):not(:active):not([data-keyboard-pressed])]:bg-creation-primary-container-surface-focused',
    '[&[data-selected]:not([data-disabled]):not(:active):not([data-keyboard-pressed])]:text-creation-primary-container-on-surface-focused',
    'active:bg-creation-primary-container-surface-pressed active:text-creation-primary-container-on-surface-pressed',
    'data-keyboard-pressed:bg-creation-primary-container-surface-pressed data-keyboard-pressed:text-creation-primary-container-on-surface-pressed',
    'data-disabled:pointer-events-none data-disabled:cursor-not-allowed data-disabled:opacity-40',
  ],
  {
    variants: {
      interaction: {
        list: [
          '[&:hover:not(:focus):not(:active):not([data-selected]):not([data-keyboard-pressed])]:bg-creation-primary-container-surface-hover',
          '[&:hover:not(:focus):not(:active):not([data-selected]):not([data-keyboard-pressed])]:text-creation-primary-container-on-surface-hover',
          '[&:focus:not(:active):not([data-keyboard-pressed])]:bg-creation-primary-container-surface-focused',
          '[&:focus:not(:active):not([data-keyboard-pressed])]:text-creation-primary-container-on-surface-focused',
        ],
        select: [
          '[&[data-highlighted]:not([data-selected]):not(:active)]:bg-creation-primary-container-surface-hover',
          '[&[data-highlighted]:not([data-selected]):not(:active)]:text-creation-primary-container-on-surface-hover',
        ],
      },
    },
    defaultVariants: {
      interaction: 'list',
    },
  },
)

export const dropdownMenuTriggerClass =
  'w-70 justify-between border-creation-neutral-container-on-surface-default px-3 py-1 text-comp-input-ip1 font-normal leading-comp-input-ip1 hover:border-creation-primary-container-on-surface-hover active:border-creation-primary-container-on-surface-pressed data-popup-open:border-creation-primary-container-on-surface-focused data-popup-open:shadow-[0_0_4px_var(--color-primary-a30)]'

export const disabledTargetChipClass =
  'border-creation-error-container-on-surface-default bg-creation-error-solid-on-surface-default text-main-text-error'

export const buttonVariants = cva(
  'inline-flex shrink-0 cursor-pointer items-center justify-center whitespace-nowrap font-semibold transition-all outline-none select-none disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        primary:
          'bg-creation-primary-solid-surface-default text-creation-primary-solid-on-surface-default ' +
          'hover:bg-creation-primary-solid-surface-hover hover:text-creation-primary-solid-on-surface-hover ' +
          'focus:bg-creation-primary-solid-surface-focused focus:text-creation-primary-solid-on-surface-focused focus:shadow-[0_0_8px_4px_var(--color-primary-a30)] ' +
          'active:bg-creation-primary-solid-surface-pressed active:text-creation-primary-solid-on-surface-pressed ' +
          'disabled:bg-creation-primary-solid-surface-disable disabled:text-creation-primary-solid-on-surface-disable',
        secondary:
          'bg-creation-secondary-container-surface-default text-creation-secondary-container-on-surface-default border border-creation-secondary-container-on-surface-default ' +
          'hover:bg-creation-primary-container-surface-hover hover:text-creation-primary-container-on-surface-hover hover:border-creation-primary-container-on-surface-hover ' +
          'focus:bg-creation-primary-container-surface-focused focus:text-creation-primary-container-on-surface-focused focus:border-creation-primary-container-on-surface-focused focus:shadow-[0_0_8px_4px_var(--color-primary-a30)] ' +
          'active:bg-creation-primary-container-surface-pressed active:text-creation-primary-container-on-surface-pressed active:border-creation-primary-container-on-surface-pressed ' +
          'disabled:bg-creation-secondary-container-surface-disable disabled:text-creation-secondary-container-on-surface-disable disabled:border-creation-secondary-container-on-surface-disable',
        ghost:
          'text-creation-secondary-container-on-surface-default ' +
          'hover:text-creation-primary-container-on-surface-hover ' +
          'focus:text-creation-primary-container-on-surface-focused ' +
          'active:text-creation-primary-container-on-surface-pressed ' +
          'disabled:text-creation-secondary-container-on-surface-disable',
        link:
          'text-creation-info-container-on-surface-default underline underline-offset-4 ' +
          'hover:bg-creation-secondary-container-surface-hover hover:text-creation-info-container-on-surface-hover ' +
          'focus:bg-creation-secondary-container-surface-focused focus:text-creation-info-container-on-surface-focused focus:shadow-[0_0_8px_4px_var(--color-primary-a30)] ' +
          'active:bg-creation-secondary-container-surface-pressed active:text-creation-info-container-on-surface-pressed active:shadow-none ' +
          'disabled:text-creation-info-container-on-surface-disable',
        danger:
          'bg-creation-error-solid-surface-default text-creation-error-solid-on-surface-default ' +
          'hover:bg-creation-error-solid-surface-hover hover:text-creation-error-solid-on-surface-hover ' +
          'focus:bg-creation-error-solid-surface-focused focus:text-creation-error-solid-on-surface-focused focus:shadow-[0_0_8px_4px_var(--color-primary-a30)] ' +
          'active:bg-creation-error-solid-surface-pressed active:text-creation-error-solid-on-surface-pressed ' +
          'disabled:bg-creation-error-solid-surface-disable disabled:text-creation-error-solid-on-surface-disable',
      },
      size: {
        sm: "h-8 px-2 py-1 rounded-200 text-comp-button-bt2 leading-comp-button-bt2 [&_svg:not([class*='size-'])]:size-4 [&_span]:px-1 [&_span]:min-w-20.75",
        md: "h-10 px-3 py-2 rounded-300 text-comp-button-bt1 leading-comp-button-bt1 [&_svg:not([class*='size-'])]:size-6 [&_span]:px-2 [&_span]:min-w-25.5",
        lg: "h-12 px-4 py-3 rounded-300 text-comp-button-bt1 leading-comp-button-bt1 [&_svg:not([class*='size-'])]:size-6 [&_span]:px-2 [&_span]:min-w-25.5",
        'icon-sm': "size-8 rounded-200 [&_svg:not([class*='size-'])]:size-4",
        'icon-md': "size-10 rounded-300 [&_svg:not([class*='size-'])]:size-6",
        'icon-lg': "size-12 rounded-300 [&_svg:not([class*='size-'])]:size-6",
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
)
